module.exports = __webpack_public_path__ + "media/images/email-1b0dedc10b2c1cb82709451b3cadbe3b.svg";